import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { authRoutes, nonAuthRoutes } from '../const';
import AuthLayout from '../components/AppLayout/AuthLayout';
import NonAuthLayout from '../components/AppLayout/NonAuthLayout';
import { ROUTES } from 'shared/const/routes';
import { getToken, getUserId, getUserMeta } from 'shared/config/store/reducers/userSlice';
import { ConfirmEmail } from 'pages/auth/confirm-email';
import { ConfirmPhone } from 'pages/auth/confirm-phone';

function AppRouter() {
  const userId = useSelector(getUserId),
    userToken = Boolean(useSelector(getToken));
  const userMeta = useSelector(getUserMeta);
  
  const needsVerification = (userMeta.id > 0 && (!userMeta.verified || !userMeta.phoneVerified));
  const isAuthenticated = userId && userToken && !needsVerification;
  const defaultRedirectPage = isAuthenticated ? ROUTES.DASHBOARD.path : ROUTES.LOGIN.path;

  return (
    <Routes>
      <Route element={<NonAuthLayout />}>
        <Route path={ROUTES.CONFIRM_EMAIL.path} element={<ConfirmEmail />} />
        <Route path={ROUTES.CONFIRM_PHONE.path} element={<ConfirmPhone />} />
      </Route>
      
      {isAuthenticated ? (
        <Route element={<AuthLayout />}>
          {authRoutes
            .filter(route => route.key !== ROUTES.CONFIRM_EMAIL.key && route.key !== ROUTES.CONFIRM_PHONE.key)
            .map((route) => (
              <Route key={route.key} path={route.path} element={route.element} />
            ))}
        </Route>
      ) : (
        <Route element={<NonAuthLayout />}>
          {nonAuthRoutes
            .filter(route => route.key !== ROUTES.CONFIRM_EMAIL.key && route.key !== ROUTES.CONFIRM_PHONE.key)
            .map((route) => (
              <Route key={route.key} path={route.path} element={route.element} />
            ))}
        </Route>
      )}
      <Route path="*" element={<Navigate to={defaultRedirectPage} replace />} />
    </Routes>
  );
}

export default AppRouter;
